import script from "./ChatMessagesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessagesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessagesPanel.vue?vue&type=style&index=0&id=728c8ee8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-728c8ee8"]])

export default __exports__